/**
 * LTI Enrollment Classes
 * LTI Enroll Class for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ArrayOfAcademicProgramsItem model module.
 * @module model/ArrayOfAcademicProgramsItem
 * @version 2.0.0
 */
class ArrayOfAcademicProgramsItem {
    /**
     * Constructs a new <code>ArrayOfAcademicProgramsItem</code>.
     * @alias module:model/ArrayOfAcademicProgramsItem
     */
    constructor() { 
        
        ArrayOfAcademicProgramsItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ArrayOfAcademicProgramsItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ArrayOfAcademicProgramsItem} obj Optional instance to populate.
     * @return {module:model/ArrayOfAcademicProgramsItem} The populated <code>ArrayOfAcademicProgramsItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ArrayOfAcademicProgramsItem();

            if (data.hasOwnProperty('end_date_join')) {
                obj['end_date_join'] = ApiClient.convertToType(data['end_date_join'], 'String');
            }
            if (data.hasOwnProperty('ended_enroll_period')) {
                obj['ended_enroll_period'] = ApiClient.convertToType(data['ended_enroll_period'], 'Boolean');
            }
            if (data.hasOwnProperty('class_certificate')) {
                obj['class_certificate'] = ApiClient.convertToType(data['class_certificate'], 'Boolean');
            }
            if (data.hasOwnProperty('joined_certificate')) {
                obj['joined_certificate'] = ApiClient.convertToType(data['joined_certificate'], 'Boolean');
            }
            if (data.hasOwnProperty('academic_program_title')) {
                obj['academic_program_title'] = ApiClient.convertToType(data['academic_program_title'], 'String');
            }
            if (data.hasOwnProperty('is_blended')) {
                obj['is_blended'] = ApiClient.convertToType(data['is_blended'], 'Boolean');
            }
            if (data.hasOwnProperty('is_extraordinary')) {
                obj['is_extraordinary'] = ApiClient.convertToType(data['is_extraordinary'], 'Boolean');
            }
            if (data.hasOwnProperty('formative_actions')) {
                obj['formative_actions'] = ApiClient.convertToType(data['formative_actions'], Object);
            }
        }
        return obj;
    }


}

/**
 * @member {String} end_date_join
 */
ArrayOfAcademicProgramsItem.prototype['end_date_join'] = undefined;

/**
 * @member {Boolean} ended_enroll_period
 */
ArrayOfAcademicProgramsItem.prototype['ended_enroll_period'] = undefined;

/**
 * @member {Boolean} class_certificate
 */
ArrayOfAcademicProgramsItem.prototype['class_certificate'] = undefined;

/**
 * @member {Boolean} joined_certificate
 */
ArrayOfAcademicProgramsItem.prototype['joined_certificate'] = undefined;

/**
 * @member {String} academic_program_title
 */
ArrayOfAcademicProgramsItem.prototype['academic_program_title'] = undefined;

/**
 * @member {Boolean} is_blended
 */
ArrayOfAcademicProgramsItem.prototype['is_blended'] = undefined;

/**
 * @member {Boolean} is_extraordinary
 */
ArrayOfAcademicProgramsItem.prototype['is_extraordinary'] = undefined;

/**
 * @member {Object} formative_actions
 */
ArrayOfAcademicProgramsItem.prototype['formative_actions'] = undefined;






export default ArrayOfAcademicProgramsItem;

